
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 68 68\" id=\"icon-upp-logo-small\" preserveAspectRatio=\"xMinYMin meet\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path class=\"filled\" fill=\"#F5D410\" d=\"M59.6,22.9l-0.1,30.4l-49.3-0.1l0.1-30.4L34.9,8.1L59.6,22.9z    M53.7,35.5l-18.3,0l0,12.6l18.3,0L53.7,35.5z\"/> </g> </symbol>";
module.exports = sprite.add(image, "icon-upp-logo-small");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/upp-logo-small.svg
 ** module id = 238
 ** module chunks = 24
 **/